
import { Prop, Vue, Component } from "vue-property-decorator";
import { DataFromActionPlans } from "@/store/custom-fields/types";
import vSelect3 from "vselect3";
import LabelDropdown from "@/components/labels/LabelDropdown.vue";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";
import { Label, LabelPagedResonse, LabelTypeQueryParams, LabelTypes } from "@/store/labels/types";
import labelApi from "@/services/api.labelSetup.service";
import { paginatedSearchExtendedMixins } from "@/mixins/paginatedSearchExtendedMixins";
import { Getter } from "vuex-class";

const { fetchAllResults } = paginatedSearchExtendedMixins.methods;

@Component({
	components: {
		"v-select-3": vSelect3,
		"label-dropdown": LabelDropdown
	}
})

export default class CustomFieldModalUpdateViewExtendedDataActionPlanResult extends Vue {
	@Prop({ required: true }) public value: DataFromActionPlans | null;

	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

	private labelOptions: Label[] = [];

	private paginatedSearchQueryParams: LabelTypeQueryParams = {
		page: 1,
		pageSize: 5,
		labelTypeId: LabelTypes.ActionPlan
	};

	private get isAutoPopulateEnabled(): boolean {
		return !!this.getFeature(["CustomFields", "NotificationTemplates", "ExtendedData", "ActionPlanResult", "AutoPopulate"]);
	}

	private get isActionPlanLabelingEnabled(): boolean {
		return !!this.getFeature(["Labelling", "ActionPlanSetup"]);
	}

	/**
	 * Lifecycle hook - fetch data when component is mounted
	 */
	private async mounted(): Promise<void> {
		try {
			await this.loadAllLabels();

			// Initialize default values if not already set
			if (!this.value?.labelIds) {
				this.value.labelIds = [];
			}

			if (this.value?.includeTaskTitle === undefined) {
				this.value.includeTaskTitle = false;
			}
		} catch (error) {
			console.error("Failed to load action plan tasks", error);
		}
	}

	/**
	 * Emit the value to parent
	 */
	private emitUpdate(): void {
		if (this.value) {
			this.$emit("input", { ...this.value });
		}
	}

	private async loadAllLabels(): Promise<void> {
		if (!this.isActionPlanLabelingEnabled) {
			return;
		}

		try {
			const request: PaginatedSearchRequest = {
				params: { ...this.paginatedSearchQueryParams },
				cancelToken: undefined
			};

			const { data } = await fetchAllResults<LabelPagedResonse>(labelApi, labelApi.GetLabelsByLabelType, request);
			this.labelOptions = data;
		} catch (error) {
			console.error("Error loading labels:", error);
		}
	}


	get includeTaskTitle(): boolean {
		return this.value?.includeTaskTitle || false;
	}

	set includeTaskTitle(newValue: boolean) {
		if (this.value) {
			this.value.includeTaskTitle = newValue;
			this.emitUpdate();
		}
	}

	get defaultActionPlan(): number[] {
		return this.value?.labelIds || [];
	}

	set defaultActionPlan(newValue: number[]) {
		if (this.value) {
			this.value.labelIds = newValue;
			this.emitUpdate();
		}
	}
}
